module.exports = __webpack_public_path__ + "img/example_glass_02.b11e4bb0.png";